import type { QuarterPlan } from '@/interfaces/Objectives.interface';

const QUARTER_MONTHS: Record<number, { start: string; end: string }> = {
  1: { start: '01-01', end: '03-31' },
  2: { start: '04-01', end: '06-30' },
  3: { start: '07-01', end: '09-30' },
  4: { start: '10-01', end: '12-31' }
};

function currentQuarter(date = new Date()): number {
  return Math.floor(date.getMonth() / 3) + 1;
}

export function formatQuarterLabel(year: number, quarter: number): string {
  return `${year} Q${quarter}`;
}

export function generateQuarterOptions(
  baseYear = new Date().getFullYear(),
  yearsAhead = 3
): QuarterPlan[] {
  const plans: QuarterPlan[] = [];
  const now = new Date();
  const currentQ = currentQuarter(now);

  for (let year = baseYear; year <= baseYear + yearsAhead; year += 1) {
    const maxQ = year === baseYear + yearsAhead ? 2 : 4;
    const minQ = year === baseYear ? 1 : 1;
    const endQ = year === baseYear + yearsAhead ? maxQ : 4;

    for (let q = year === baseYear ? currentQ : minQ; q <= endQ; q += 1) {
      const range = QUARTER_MONTHS[q];
      const isCurrent = year === now.getFullYear() && q === currentQ;
      const quarterEnd = new Date(`${year}-${range.end}`);
      const isLocked = quarterEnd < now && !isCurrent;

      plans.push({
        id: year * 10 + q,
        label: formatQuarterLabel(year, q),
        start_date: `${year}-${range.start}`,
        end_date: `${year}-${range.end}`,
        is_locked: isLocked,
        is_current: isCurrent
      });
    }
  }

  return plans;
}

export function quarterSelectOptions(plans: QuarterPlan[]) {
  return plans.map((plan) => ({
    label: plan.label,
    value: plan.id
  }));
}
